import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-collabo-portal-kanri-login',
  templateUrl: './collabo-portal-kanri-login.component.html',
  styleUrls: [
    './collabo-portal-kanri-login.component.css',
    '../style/global.css',
  ],
})
export class CollaboPortalKanriLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}
}
